// This is generated.  Alter it in blockGroups/actionElements/types/Button.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { actionUtils, config } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context = {},
    parentAccessRestrictions,
  ) {
    const { namespace, relation } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    if (accessRestrictions.hidden) return [{}, {}];

    // Buttons can act on a relation other than the one they are displayed on.
    // For example, an item:item button can save application:sharedFilter.
    const actionTarget = actionUtils.getActionTarget(hNode);
    const normalizedAction = actionTarget.action;
    const targetNamespace = actionTarget.namespace || namespace;
    const targetRelation = actionTarget.relation || relation;

    // accessContext says what the button can do in the UI. routeAccessHints below
    // is the separate "the API route should exist because this button needs it" signal.
    const accessContext = actionUtils.buildWriteAccessContextForAction(
      normalizedAction,
      hNode.blockId,
    );

    // Respect read-only restrictions: visible UI can show the button, but it should not
    // contribute write capabilities to route access / OpenAPI generation.
    if (accessRestrictions.readOnly) {
      accessContext.post.value = false;
      accessContext.patch.value = false;
      accessContext.remove.value = false;
    }

    // Only keep true methods as route hints. False values are not useful requests,
    // and dropping them keeps later schema merges easy to read.
    const routeAccessHints = Object.entries(accessContext).reduce(
      (hints, [method, access]) => {
        if (access?.value) hints[method] = access;
        return hints;
      },
      {},
    );

    // Build an (extendable) relation schema; additionalProperties: true so other nodes can add props.
    const relationSchema = Type.Object(
      {},
      {
        title: targetRelation,
        // additionalProperties: true allows other blocks to extend this relation
        // This enables adding properties to the relation without breaking validation
        additionalProperties: true,
        ...(normalizedAction ? { 'x-forAction': normalizedAction } : {}),
        'x-accessRestrictions': accessRestrictions,
        'x-accessContext': accessContext,
        ...(Object.keys(routeAccessHints).length
          ? { 'x-routeAccessHints': routeAccessHints }
          : {}),
      },
    );

    // subDataDictionary defines the namespace/relation structure for metadata assembly
    // This creates the hierarchical structure: namespace -> relation -> schema
    const subDataDictionary = {
      [targetNamespace]: {
        [targetRelation]: relationSchema,
      },
    };

    // This button does not contribute local properties to the form
    // partialTypeDefinition remains empty as buttons are actions, not data fields
    const partialTypeDefinition = {};

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'actionElements',
  'Button',
  module.exports,
);
